import { Component, input, TemplateRef } from '@angular/core';
/**
 * @description A component that displays a label with an associated info point.
 * This component can show a label text, informational text, and optionally use a custom template.
 * It also supports binding to form controls and indicating if the field is required.
 *
 * @example
 * <label-info-point
 *   label="Username"
 *   textInfo="Enter your username here"
 *   [for]="usernameInput"
 *   [required]="true">
 * </label-info-point>
 *
 * @selector label-info-point
 */

@Component({
  selector: 'label-info-point',
  templateUrl: './label-info-point.component.html',
  styleUrls: ['./label-info-point.component.scss'],
})
export class LabelInfoPointComponent {
  /**
   * The label text for the info point.
   */
  label = input<string | undefined>();

  /**
   * The informational text to display.
   */
  textInfo = input<string | undefined>();

  /**
   * A custom template to use for rendering the info point.
   */
  template = input<TemplateRef<any> | undefined>();

  /**
   * The ID of the associated form control.
   */
  for = input<string | undefined>();

  /**
   * Indicates whether the associated form control is required.
   */
  required = input<boolean>(false);
}
